if (!window.customElements.get('gtc-faq-navivation')) {
  class GtcFaqNavigation extends HTMLElement {
    constructor() {
      super();
      // Add your custom initialization code here

      this.dom = {
        main: this,
        list: this.querySelector('ul'),
        template: this.querySelector('template')
      }
      this.settings = {
        faqSections: []
      }
    }

    connectedCallback() {
      // Add your code to run when the element is inserted into the DOM
      this.GetFaqSections();
      this.CreateNavigation();
      this.NavigationItemClick();

      if (this.dom.main.hasAttribute('sticky')) {
        this.SetVariableHeight();
      }

      const url = new URL(window.location.href);
      if (url.hash){

        const navItems = [...this.dom.list.querySelectorAll('.gtc\\:faq-navigation__link')];
        const navItemsWithMatchingHref = navItems.filter(navItem => navItem.getAttribute('href') === url.hash);

        if (navItemsWithMatchingHref.length > 0) {
          this.ScrollNavigationIntoView(navItemsWithMatchingHref[0]);
        }
      }

    }

    GetFaqSections() {
      this.settings.faqSections = document.querySelectorAll('main .gtc\\:faq');
    }

    CreateNavigation() {
      this.settings.faqSections.forEach(faqSection => {
        const navItemHtml = this.dom.template.content.cloneNode(true);
        const id = faqSection.id;
        const title = faqSection.querySelector('.gtc\\:faq__title')?.textContent;

        if (!id || !title) {
          console.error('FAQ section is missing an id or title');
          return;
        }

        const link = navItemHtml.querySelector('[slot="link"]');
        link.href = `#${ id }`;
        link.textContent  = title;

        this.dom.list.appendChild(navItemHtml);
      });
    }

    NavigationItemClick() {
      this.dom.list.addEventListener('click', (e) => {
        if (e.target.matches('a')) {
          e.preventDefault();
          const target = e.target;
          const id = target.getAttribute('href');
          const faqSection = document.querySelector(id);
          if (faqSection) {
            // this.SetUrlUrlParams(faqSection.id);

            if (this.dom.list.getAttribute('sticky')) {
              this.SetVariableHeight();
            }

            this.ScrollNavigationIntoView(target);

            faqSection.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }
      });
    }

    SetUrlUrlParams(id) {
      const url = new URL(window.location.href);
      url.hash = id;
      window.history.replaceState({}, '', url);
    }


    ScrollNavigationIntoView(target) {
      const scrollLeft = target.offsetLeft - this.dom.list.offsetLeft;
      this.dom.list.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }

    SetVariableHeight() {
      document.documentElement.style.setProperty('--faq-navigation-height', this.dom.main.offsetHeight + 'px');
    }
  }

  // Define the custom element
  customElements.define('gtc-faq-navivation', GtcFaqNavigation);
}
